import { P2TextDescription } from 'react-bootstrap-common-script'
import { useGetSubmittedDocumentsQuery } from '../../../redux/services/getStageE';
import { useAppSelector } from '../../../redux/hook';
import { LottieLoader } from '../../../components/loader';
import { Separator } from '../../../components/separator';

function DocumentsToBringSegment() {
  const queryParameters = new URLSearchParams(window.location.search);
  const application_id = queryParameters.get("application_id");
  const loginUser = useAppSelector((state)=>state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state)=>state.auth.AuthenticationSlice.singpassToken);

  const { data, isLoading } = useGetSubmittedDocumentsQuery({application_id: application_id ?? "0", uinfin: loginUser?.uinfin ?? "", singpass_token: singpassToken ?? ""}, {skip: application_id === "0" || application_id === null});

  if(isLoading){
    return <>
      <LottieLoader/>
    </>
  }
  if(data?.length === 0){
    return <></>
  }
  return (
    <>
      <div className='polymer-stage-e-documents_bring px-4'>
        <P2TextDescription color='#333' title={"Documents to Bring"} description={"Please prepare the following documents in hard copy for our verification during the completion appointment."} />
        <div className='polymer-stage-e-card'>
          {data.map((e:any, index:number)=>{
            const key = index;

            return <p key={key}>{index + 1}. {e.label}</p>
          })}
        </div>
      </div>
      <Separator variant='solid' style={{ margin: "48px 0 24px" }} />
    </>
  )
}

export default DocumentsToBringSegment